import { Link } from "react-router-dom";

export default function PublicLogoLink({ src, alt, className }) {
    return (
        <Link
            to="/"
            aria-label="Go to FirmFlow home"
            className="inline-flex cursor-pointer no-underline"
        >
            <img src={src} alt={alt} className={className} />
        </Link>
    );
}
